<template>
  <v-card class="d-flex align-center justify-center pa-10" light outlined>
    <div>
      <div class="d-flex justify-center">
        <v-img class="mb-3" position="center center" src="https://swiset.com/wp-content/uploads/2021/02/Swiset-Pro-Feature.png" max-width="77px" contain/>
      </div>
      <h2 class="text-center">{{ $t('title') }}</h2>
      <p class="text-center">{{ $t('description') }}</p>
      <v-btn class="button-convert" style="width: 100%" @click="goToPro">{{ $t('btnSeeBenefits') }} »</v-btn>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "ProStatAlert",
  methods: {
    goToPro() {
      this.$emit('goToPro');
    }
  }
}
</script>

<i18n>
{
  "en": {
    "title": "Pro Stat",
    "description": "This is an exclusive stat for Swiset Pro users",
    "btnSeeBenefits": "See Pro Benefits"
  },
  "es": {
    "title": "Estadística Pro",
    "description": "Es una estadística exclusiva para usuarios Swiset Pro",
    "btnSeeBenefits": "Mira los Beneficios Pro"
  }
}
</i18n>

<style scoped>
.button-convert {
  background-color: #111111 !important;
  color: #ffffff !important;
  border: #111111 solid 1px;
}
</style>
